import { Injectable } from "@angular/core";
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: "root",
})
export class ToastService {
  private static queue: string[] = [];
  private static isToastActive: boolean = false;
  constructor() {}

  static async makeToast(msg: string) {
    this.queue.push(msg);

    // Starte die Toast-Anzeige, wenn sie noch nicht läuft
    if (!this.isToastActive) {
      await this.showNextToast();
    }
  }
  static async makeLowToast(msg: string) {
    this.queue.push(msg);

    if (!this.isToastActive) {
      await this.showNextToast("bottom");
    }
  }

  private static async showNextToast(position: "middle" | "bottom" = "middle") {
    if (this.queue.length === 0) {
      this.isToastActive = false;
      return;
    }

    // Markiere, dass ein Toast aktiv ist
    this.isToastActive = true;

    // Nimm die nächste Nachricht aus der Warteschlange
    const msg = this.queue.shift();

    // Erstelle und zeige den Toast
    const toast = document.createElement("ion-toast");
    toast.message = msg!;
    toast.duration = 3000;
    toast.position = position;
    // Eigene Klasse statt der Ionic-Standardfarben: die lagen so nah am
    // hellen Seitengrund, dass eine Meldung mitten auf der Seite kaum zu sehen
    // war. Siehe .meloToast in global.scss.
    toast.className = "ion-text-center meloToast";
    document.body.appendChild(toast);

    // Warte, bis der Toast angezeigt wurde und abgeschlossen ist
    await toast.present();
    await new Promise(resolve => setTimeout(resolve, 3000)); // Warte die Dauer des Toasts ab

    // Entferne den Toast aus dem DOM
    toast.dismiss();

    // Zeige den nächsten Toast in der Warteschlange
    await this.showNextToast(position);
  }

  static async presentToast(aMessage: string, position: 'top' | 'middle' | 'bottom' = 'bottom') {
    const toastCrtl = new ToastController();
    const toast = await toastCrtl.create({
      message: aMessage,
      duration: 3000,
      position: position,
      cssClass: "ion-text-center"
    });

    await toast.present();
  }
}
